import { IOrderNotesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useOrderNotes = (orderId: string | undefined): IOrderNotesHook => {
  const { orderStore } = useStore();
  const {
    orderNotes,
    orderNotesTotalCount,
    orderNotesCurrentPage,
    orderNotesSkipCount,
    orderNotesMaxResultCount,
    orderNotesLoading,
    handleOrderNotesPageChange,
  } = orderStore;

  useEffect(() => {
    return () => orderStore.resetOrderNotes();
  }, [orderStore]);

  useEffect(() => {
    orderId &&
      orderStore.getOrderNotes({
        orderId,
        skipCount: orderNotesSkipCount,
        maxResultCount: orderNotesMaxResultCount,
      });

    return () => {
      orderStore.clearOrderNotes();
    };
  }, [orderStore, orderId, orderNotesSkipCount, orderNotesMaxResultCount]);

  return {
    loading: orderNotesLoading,
    dataSource: Array.from(orderNotes.values()),
    totalCount: orderNotesTotalCount,
    skipCount: orderNotesSkipCount,
    currentPage: orderNotesCurrentPage,
    maxResultCount: orderNotesMaxResultCount,
    handlePageChange: handleOrderNotesPageChange,
  };
};
